import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { DividendsList } from "~/api/types/DividendsList"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Wrapper } from "~/components/Wrapper/Wrapper"
import { formatDateNew } from "~/helpers/formatDate"

import styles from "./index.module.css"

export const History: React.FC = () => {
  const { t } = useTranslation()
  const dividents = useApiContext("/dividends/list")

  return (
    <Wrapper>
      <div className="container">
        <Heading className={styles.Title} like="h2">
          <Raw html={t("stock.Dividends.History.Title")} />
        </Heading>

        <div className={styles.Table}>
          <div className={styles.TableWrapper}>
            <div className={styles.TableInner}>
              <div className={styles.RowHeading}>
                <div className={styles.CellHeading}>
                  <Raw html={t("stock.Dividends.History.Table.Title_01")} />
                </div>
                <div className={styles.CellHeading}>
                  <Raw html={t("stock.Dividends.History.Table.Title_02")} />
                </div>
                <div className={styles.CellHeading}>
                  <Raw html={t("stock.Dividends.History.Table.Title_03")} />
                </div>
                <div className={styles.CellHeading}>
                  <Raw html={t("stock.Dividends.History.Table.Title_04")} />
                </div>
                <div className={styles.CellHeading}>
                  <Raw html={t("stock.Dividends.History.Table.Title_05")} />
                </div>
                <div className={styles.CellHeading}>
                  <Raw html={t("stock.Dividends.History.Table.Title_06")} />
                </div>
              </div>
              <Dividends dividents={dividents} />
            </div>

            <div className={styles.Note}>
              <Raw html={t("stock.Dividends.History.Note")} />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Dividends: React.FC<{ dividents: DividendsList[] }> = ({ dividents }) => (
  <>
    {dividents.map(
      (
        { comment, dividendsAmount, dividendsPaid, dividendsPerShare, year, updateDate, paidDate },
        i,
      ) => (
        <div key={i} className={styles.Row}>
          <div className={styles.Cell}>
            {year}
            {comment && <span>{comment}</span>}
          </div>
          <div className={styles.Cell}>{dividendsAmount}</div>
          <div className={styles.Cell}>{dividendsPerShare}</div>
          <div className={styles.Cell}>{formatDateNew(updateDate, "dd.MM.yy")}</div>
          <div className={styles.Cell}>{formatDateNew(paidDate, "dd.MM.yy")}</div>
          <div className={styles.Cell}>{dividendsPaid}</div>
        </div>
      ),
    )}
  </>
)
